// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/@radix-ui/colors/black-alpha.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/@radix-ui/colors/mauve.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/@radix-ui/colors/violet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContextMenuContent,
.ContextMenuSubContent {
  min-width: 135px;
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
  padding: 5px;
  box-shadow:
    0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  z-index: 99;
}

.ContextMenuItem,
.ContextMenuCheckboxItem,
.ContextMenuRadioItem,
.ContextMenuSubTrigger {
  font-size: 13px;
  line-height: 1;
  color: var(--violet-11);
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 25px;
  padding: 0 5px;
  position: relative;
  padding-left: 15px;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
}

.ContextMenuSubTrigger[data-state="open"] {
  background-color: gray;
  color: var(--violet-11);
}

.ContextMenuItem[data-disabled],
.ContextMenuCheckboxItem[data-disabled],
.ContextMenuRadioItem[data-disabled],
.ContextMenuSubTrigger[data-disabled] {
  color: var(--mauve-8);
  pointer-events: "none";
}

.ContextMenuItem[data-highlighted],
.ContextMenuCheckboxItem[data-highlighted],
.ContextMenuRadioItem[data-highlighted],
.ContextMenuSubTrigger[data-highlighted] {
  background-color: #dad9db;
  color: var(--violet-11);
}

.ContextMenuLabel {
  padding-left: 25px;
  font-size: 12px;
  line-height: 25px;
  color: var(--mauve-11);
}

.ContextMenuItemIndicator {
  position: absolute;
  left: 0;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.RightSlot {
  margin-left: auto;
  padding-left: 20px;
  color: var(--mauve-11);
}

[data-highlighted] > .RightSlot {
  color: white;
}

[data-disabled] .RightSlot {
  color: var(--mauve-8);
}

.dropdown-menu {
  min-width: 10rem;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.3rem 1.2rem;
  clear: both;
  font-weight: 400;
  color: #393a39;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #dad9db;
  color: var(--violet-11);
}

.modal {
  margin-top: 50px;
}
.pdfName {
  font-size: 10px;
  font-weight: 600;
}


.hrStyle {
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.status-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #fff;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-badge i {
  font-size: 12px;
}

/* Status-specific colors */
.completed {
  background-color: #4caf50;
  color: #fff;
}

.in-progress {
  background-color: #ffc107;
  color: #fff;
}

.declined {
  background-color: #f44336;
  color: #fff;
}

.expired {
  background-color: #9e9e9e;
  color: #fff;
}

.draft {
  background-color: #079cdc;
  color: #fff;
}


.sort {
  padding: 8px 15px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sort:hover {
  box-shadow: 0 2px 4px rgba(168, 204, 206, 0.1);
  background-color: var(--mauve-3);
  border-radius: 2px;
}

.fileName {
  display: inline-block;
  width: 100px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  font-size: 11px;
  text-align: center;
  font-weight: 480;
}
.select-none-cls{
  -webkit-user-select: none;
  /* Disable text selection in WebKit browsers */
  user-select: none;
}

a {
  all: unset;
}

.HoverCardContent {
  border-radius: 6px;
  padding: 5px 10px;
  width: 170px;
  background-color: white;
  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  text-align: center;
  align-items: center;
}

.HoverCardContent[data-side="top"] {
  animation-name: slideDownAndFade;
}

.HoverCardContent[data-side="right"] {
  animation-name: slideLeftAndFade;
}

.HoverCardContent[data-side="bottom"] {
  animation-name: slideUpAndFade;
}

.HoverCardContent[data-side="left"] {
  animation-name: slideRightAndFade;
}

.HoverCardArrow {
  fill: white;
}

@keyframes slideUpAndFade {
  0% {
    opacity: 0;
    transform: translateY(2px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideRightAndFade {
  0% {
    opacity: 0;
    transform: translateX(-2px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideDownAndFade {
  0% {
    opacity: 0;
    transform: translateY(-2px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideLeftAndFade {
  0% {
    opacity: 0;
    transform: translateX(2px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (min-width: 310px) and (max-width: 550px) {
  .sort {
    padding: 2px;
  }
}

@media screen and (max-width: 309px) {
  .sort {
    padding: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/opensigndrive.css"],"names":[],"mappings":"AAIA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ;;6CAE2C;EAC3C,WAAW;AACb;;AAEA;;;;EAIE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;EAIE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,8CAA8C;EAE9C,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB;;6CAE2C;EAC3C,yBAAyB;EACzB,wDAAwD;EACxD,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["@import \"@radix-ui/colors/black-alpha.css\";\n@import \"@radix-ui/colors/mauve.css\";\n@import \"@radix-ui/colors/violet.css\";\n\n.ContextMenuContent,\n.ContextMenuSubContent {\n  min-width: 135px;\n  background-color: white;\n  border-radius: 6px;\n  overflow: hidden;\n  padding: 5px;\n  box-shadow:\n    0px 10px 38px -10px rgba(22, 23, 24, 0.35),\n    0px 10px 20px -15px rgba(22, 23, 24, 0.2);\n  z-index: 99;\n}\n\n.ContextMenuItem,\n.ContextMenuCheckboxItem,\n.ContextMenuRadioItem,\n.ContextMenuSubTrigger {\n  font-size: 13px;\n  line-height: 1;\n  color: var(--violet-11);\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  height: 25px;\n  padding: 0 5px;\n  position: relative;\n  padding-left: 15px;\n  user-select: none;\n  outline: none;\n}\n\n.ContextMenuSubTrigger[data-state=\"open\"] {\n  background-color: gray;\n  color: var(--violet-11);\n}\n\n.ContextMenuItem[data-disabled],\n.ContextMenuCheckboxItem[data-disabled],\n.ContextMenuRadioItem[data-disabled],\n.ContextMenuSubTrigger[data-disabled] {\n  color: var(--mauve-8);\n  pointer-events: \"none\";\n}\n\n.ContextMenuItem[data-highlighted],\n.ContextMenuCheckboxItem[data-highlighted],\n.ContextMenuRadioItem[data-highlighted],\n.ContextMenuSubTrigger[data-highlighted] {\n  background-color: #dad9db;\n  color: var(--violet-11);\n}\n\n.ContextMenuLabel {\n  padding-left: 25px;\n  font-size: 12px;\n  line-height: 25px;\n  color: var(--mauve-11);\n}\n\n.ContextMenuItemIndicator {\n  position: absolute;\n  left: 0;\n  width: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.RightSlot {\n  margin-left: auto;\n  padding-left: 20px;\n  color: var(--mauve-11);\n}\n\n[data-highlighted] > .RightSlot {\n  color: white;\n}\n\n[data-disabled] .RightSlot {\n  color: var(--mauve-8);\n}\n\n.dropdown-menu {\n  min-width: 10rem;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.3rem 1.2rem;\n  clear: both;\n  font-weight: 400;\n  color: #393a39;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #dad9db;\n  color: var(--violet-11);\n}\n\n.modal {\n  margin-top: 50px;\n}\n.pdfName {\n  font-size: 10px;\n  font-weight: 600;\n}\n\n\n.hrStyle {\n  margin-top: 0rem !important;\n  margin-bottom: 0rem !important;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.status-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #fff;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.status-badge i {\n  font-size: 12px;\n}\n\n/* Status-specific colors */\n.completed {\n  background-color: #4caf50;\n  color: #fff;\n}\n\n.in-progress {\n  background-color: #ffc107;\n  color: #fff;\n}\n\n.declined {\n  background-color: #f44336;\n  color: #fff;\n}\n\n.expired {\n  background-color: #9e9e9e;\n  color: #fff;\n}\n\n.draft {\n  background-color: #079cdc;\n  color: #fff;\n}\n\n\n.sort {\n  padding: 8px 15px;\n  margin: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.sort:hover {\n  box-shadow: 0 2px 4px rgba(168, 204, 206, 0.1);\n  background-color: var(--mauve-3);\n  border-radius: 2px;\n}\n\n.fileName {\n  display: inline-block;\n  width: 100px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n  font-size: 11px;\n  text-align: center;\n  font-weight: 480;\n}\n.select-none-cls{\n  -webkit-user-select: none;\n  /* Disable text selection in WebKit browsers */\n  -moz-user-select: none;\n  user-select: none;\n}\n\na {\n  all: unset;\n}\n\n.HoverCardContent {\n  border-radius: 6px;\n  padding: 5px 10px;\n  width: 170px;\n  background-color: white;\n  box-shadow:\n    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n  text-align: center;\n  align-items: center;\n}\n\n.HoverCardContent[data-side=\"top\"] {\n  animation-name: slideDownAndFade;\n}\n\n.HoverCardContent[data-side=\"right\"] {\n  animation-name: slideLeftAndFade;\n}\n\n.HoverCardContent[data-side=\"bottom\"] {\n  animation-name: slideUpAndFade;\n}\n\n.HoverCardContent[data-side=\"left\"] {\n  animation-name: slideRightAndFade;\n}\n\n.HoverCardArrow {\n  fill: white;\n}\n\n@keyframes slideUpAndFade {\n  0% {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideRightAndFade {\n  0% {\n    opacity: 0;\n    transform: translateX(-2px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideDownAndFade {\n  0% {\n    opacity: 0;\n    transform: translateY(-2px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideLeftAndFade {\n  0% {\n    opacity: 0;\n    transform: translateX(2px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media (min-width: 310px) and (max-width: 550px) {\n  .sort {\n    padding: 2px;\n  }\n}\n\n@media screen and (max-width: 309px) {\n  .sort {\n    padding: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
